import { isNumeric } from '../types/lib';
import { QUERY } from '@sonar-software/sonar-ts-constants';

import { defaultDecoder, parse } from 'qs';

const castValues: Record<string, unknown> = {
	false: false,
	null: null,
	true: true,
	undefined: undefined
};

export function trimSearchQuery(query = '') {
	return query?.substring(query.indexOf('?') + 1);
}

export function parseQueryString(query: string | undefined): { [key: string]: unknown } {
	const trimmedQuery = trimSearchQuery(query);

	return parse(trimmedQuery, {
		decoder: (str: string, decoder: defaultDecoder, charset: string, type: 'key' | 'value') => {
			if (type === 'value' && isNumeric(str) && (str.length === 1 || !str.toString().startsWith('0'))) {
				return Number(str);
			}

			if (type === 'value' && str in castValues) {
				return castValues[ str ];
			}

			return decoder(str, decoder, charset);
		}
	});
}

export function getQueryStringParameter(query: string, key: string): string {
	const trimmedQuery = trimSearchQuery(query);
	const parameters = parse(trimmedQuery);

	return parameters[ key ] as string;
}

export function getIdTokenQuery(query: string): string | undefined {
	return getQueryStringParameter(query.slice(1), QUERY.OIDC_TOKEN);
}

export function toArray(val: string | string[] | undefined): string[] {
	if (val) {
		return typeof val === 'string' ? [ val ] : val;
	}

	return [];
}
